import OItemDetailsOtg from './o-item-details-otg.vue';

export default OItemDetailsOtg;